import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import {
  formatReport,
  processReport,
} from './utils';

const PREREPORT_URL = `${API_CONFIG.API}/node/prereport`;
const PREREPORT_BY_OP_URL = `${API_CONFIG.API}/node/operation?include=prereport&filter[uuid][value]=`;
const EMPLOYEE_URL = `${API_CONFIG.API}/node/employee`;
export default {
  savePreReport(report) {
    return base.http().post(`${PREREPORT_URL}`, formatReport(report))
      .then(res => processReport(res.data.data));
  },
  updatePreReport(report) {
    return base.http().patch(`${PREREPORT_URL}/${report.id}`, formatReport(report))
      .then(res => processReport(res.data.data));
  },
  getEmployees() {
    return base.http().get(`${EMPLOYEE_URL}`);
  },
  getReportByOperationId(id) {
    return base.http().get(`${PREREPORT_BY_OP_URL}${id}`)
      .then((res) => {
        if ('included' in res.data) {
          return processReport(res.data.included[0]);
        }
        return {
          pr_comercial: '',
          pr_juridico: '',
          pr_financiero: '',
          pr_final: '',
          id: '',
        };
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-propuesta/service.js